import { Fragment } from 'react'

import Button from 'components/common/Button'
import Text from 'components/common/Text'
import TrackedExternalLink from 'components/common/TrackedExternalLink'
import theme from 'theme'

import { DashboardClientTag } from './AgentsCard'

export default function InstallHostInfoRow() {
  return (
    <Fragment>
      <div
        css={{
          display: 'grid',
          columnGap: theme.space[3],
          rowGap: theme.space[1],
          gridTemplateColumns: `${theme.space[7]}px 1fr`,
          alignItems: 'center'
        }}
      >
        <DashboardClientTag clientState="IDLE" label="INSTALL" />
        <div>
          <Text
            as="h6"
            css={{
              fontSize: theme.fontSizes[1],
              fontWeight: theme.fontWeights[1]
            }}
          >
            Install your own hosts
          </Text>
          <div>Your host will appear here</div>
        </div>
      </div>
      <Button
        secondary
        as={TrackedExternalLink}
        css={{
          justifyContent: 'center',
          padding: theme.space[2],
          paddingLeft: theme.space[3],
          paddingRight: theme.space[3]
        }}
        href="https://www.gremlin.com/docs/infrastructure-layer/installation/"
        label="Documentation"
      />
    </Fragment>
  )
}
